<div class="relative h-44">
  <app-upload-dropzone-border
    class="absolute inset-0"
    size="md">
    <div
      class="mx-auto flex flex-col items-center justify-center gap-3 text-center">
      <div class="flex flex-col items-center gap-3">
        <div>Przeciągaj pliki, przesyłaj nowe lub wybierz je z biblioteki.</div>

        <div class="flex gap-3">
          <p-button
            (onClick)="handleSendFileClick()"
            [disabled]="disabled()"
            appPrimengButton
            label="Prześlij"
            severity="primary"
            styleClass="z-10" />

          <p-button
            (onClick)="handleMultimediaLibraryClick()"
            [disabled]="disabled()"
            [outlined]="true"
            appPrimengButton
            label="Biblioteka mediów"
            styleClass="z-10" />
        </div>
      </div>

      <span class="text-sm font-medium text-gray-500">
        Maksymalna wielkość dodawanych plików: {{ maxFileSize() | filesize }}.
      </span>
    </div>
  </app-upload-dropzone-border>
</div>
